import React from "react";
// MUI Components
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";

// Other Files
import { customTheme } from "../../constants/customTheme";
import classNames from "classnames";

const useStyles = makeStyles({
  root: (props) => customTheme(props.theme).dialog.root,
  buttonContainer: customTheme().dialog.buttonContainer,
  title: customTheme().dialog.title,
  contentContainer: {
    ...customTheme().dialog.contentContainer,
    alignItems: "center",
  },
  contentItem: customTheme().dialog.contentItem,
  buttonPrimary: (props) => customTheme(props.theme).buttonPrimary,
  buttonOutlined: (props) => customTheme(props.theme).buttonOutlined,
  listRoot: {
    ...customTheme().dialog.contentItem,
    marginTop: "25px",
  },
  listItem: {
    padding: "0px",
  },
});

const TemplateDialog = (props) => {
  const classes = useStyles(props);

  const handleCancel = () => {
    props.cancel();
  };

  const handleSubmit = () => {
    props.submit({
      id: props.info.id,
      startedAt: props.info.startedAt,
      studyDate: props.info.studyDate,
      participantId: props.info.participantId,
      skinType: props.info.skinType,
      gender: props.info.gender,
      birthYear: props.info.birthYear,
      protocolId: props.info.protocolId,
      protocolName: props.info.protocolName,
      otherId: props.info.otherId,
    });
  };

  return (
    <Dialog
      open={props.open}
      PaperProps={{ className: classNames(classes.root) }}
    >
      {/* INFORMATION CARD */}
      <Typography
        variant="h4"
        color="textPrimary"
        align="center"
        className={classes.title}
      >
        Follow-Up Study
      </Typography>

      <DialogContent className={classes.contentContainer}>
        <Typography
          className={classes.contentItem}
          color="textPrimary"
          align="center"
        >
          {`Starting a follow-up study for ${props.info.participantId} with the following participant information. Participant information cannot be edited through a follow-up study.`}
        </Typography>

        <List disablePadding className={classes.listRoot}>
          <ListItem className={classes.listItem}>
            <ListItemText
              primary={`Participant ID: ${props.info.participantId}`}
            />
          </ListItem>
          <ListItem className={classes.listItem}>
            <ListItemText
              primary={`Other ID: ${
                props.info.otherId === "" ? "-" : props.info.otherId
              }`}
            />
          </ListItem>
          <ListItem className={classes.listItem}>
            <ListItemText
              primary={`Birth Year: ${
                props.info.birthYear === "" ? "-" : props.info.birthYear
              }`}
            />
          </ListItem>
          <ListItem className={classes.listItem}>
            <ListItemText
              primary={`Skin Type: ${
                props.info.skinType === "" ? "-" : props.info.skinType
              }`}
            />
          </ListItem>
          <ListItem className={classes.listItem}>
            <ListItemText
              primary={`Gender: ${
                props.info.gender === "" ? "-" : props.info.gender
              }`}
            />
          </ListItem>
        </List>
      </DialogContent>
      <DialogActions className={classes.buttonContainer}>
        <Button
          className={classes.buttonOutlined}
          onClick={() => handleCancel()}
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          onClick={() => handleSubmit()}
          variant="contained"
          color="primary"
          className={classes.buttonPrimary}
        >
          Start Study
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TemplateDialog;
